import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { __decorate } from "tslib";
import { Component, inject, provide } from 'intact-vue-next';
import { ROOT_MENU, MENU } from './menu';
import template from './item.vdt';
import { bind } from '../utils';
import { useExpanded } from './useExpanded';
import { useDropdown } from './useDropdown';
import { useRouter, navigate } from '../../hooks/useRouter';
import { useRecordItem } from '../../hooks/useRecordComponent';
import { MENU_RECORD_KEY, useHighlightItem } from './useHighlight';
import { useConfigContext } from '../config';
var typeDefs = {
  key: {
    type: [String, Number],
    required: true
  },
  to: [String, Object],
  dot: Boolean,
  disabled: Boolean
};
var events = {
  click: true,
  select: true
};
export var MENU_ITEM = 'MenuItem';
export var MenuItem = /*#__PURE__*/function (_Component) {
  _inheritsLoose(MenuItem, _Component);
  function MenuItem() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.rootMenu = inject(ROOT_MENU);
    _this.parentMenu = inject(MENU);
    _this.parentMenuItem = inject(MENU_ITEM, null);
    _this.expanded = useExpanded(_this.rootMenu, _this.parentMenu);
    _this.dropdown = useDropdown(_this.rootMenu, _this.parentMenu);
    _this.router = useRouter();
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = MenuItem.prototype;
  _proto.init = function init() {
    provide(MENU_ITEM, this);
    useRecordItem(MENU_RECORD_KEY);
    useHighlightItem();
  };
  _proto.onClick = function onClick(hasSubMenu, e) {
    var _this$get = this.get(),
      disabled = _this$get.disabled,
      to = _this$get.to,
      key = _this$get.key;
    if (disabled) return;
    if (hasSubMenu) {
      this.expanded.toggle();
    } else {
      this.rootMenu.highlight.select(key);
    }
    this.trigger('click', e);
    if (!hasSubMenu) {
      this.trigger('select', this, e);
      navigate(this.router.value, to);
    }
  };
  return MenuItem;
}(Component);
MenuItem.template = template;
MenuItem.typeDefs = typeDefs;
MenuItem.events = events;
__decorate([bind], MenuItem.prototype, "onClick", null);